import React, {useState} from 'react';
import {PageHero} from '../../components/page-hero';
import Layout from '../../components/layout/layout';
//import Button from "../../components/button";
import './styles.scss';
import Section from '../../components/section';
import PricingFooter from '../../components/pricing/pricingFooter';
import PricingPackeges from '../../components/pricing/pricingPackeges';
//import { navigate } from "gatsby";
import Switch from '../../components/switch';
import PremiumCredits from '../../components/pricing/premium-credits';

const Pricing = ({pageContext}: any) => {
  const [annual, setAnnual] = useState(true);
  const ltd = false;
  return (
    <Layout>
        <PageHero
          title="Hexomatic Pricing Plans"
          subtitle="Hexomatic helps businesses of all sizes scale via no code data extraction and work automation."
          // noPaddingBottom
          titleSmall
          // className="pricing-page"
          // subtitle2="Ahead of the launch, we would like to invite you today to be one of the very first to get access to Hexomatic and secure a very special early bird pre-launch lifetime deal.
          // Because this is our most ambitious idea to date, we want to soft launch first with a small cohort of our own paid customers first before opening the doors to the public later in the year.
          // This will enable us to prioritize our last mile development based on your business needs, feedback and suggestions."
          // subtitle3={
          //   <p>So here is the plan: We are opening <strong>3000 pre-launch seats</strong> for existing paid customers only. As usual, we always offer our best pricing to our own customers first so this is your chance to secure our legendary pre-launch lifetime deal at a fraction of the cost.</p>
          // }
          // subtitle4={
          //   <p>The offer ends on <strong>Thursday the 22nd at midnight</strong> (or when we reach the 3000 seats allocation). Pre-launch customers will then get first access to Hexomatic on the May 22nd with a public launch planned later this year at a higher price point.</p>
          // }
          // subtitle5='Your purchase will be covered by a 30 day refund period starting from the date of the soft launch planned on the May 22nd.'
          // countdown
        />

        <Section>
          <div className="pricing-section">
            {!ltd && (
              <div className="d-flex pricing-section-header mb-3">
                <Switch
                  text1="Monthly"
                  text2="Annually"
                  active={!annual}
                  onChange={(val: string) => setAnnual(val === 'Annually')}
                />
                {annual && (
                  <div className="d-flex align-items-center justify-content-center get-month">
                    (Get two months free)
                  </div>
                )}
              </div>
            )}
            <PricingPackeges interval={ltd ? 'ltd' : annual ? 'annual' : 'monthly'} products={pageContext.products} />
            <PricingFooter />
          </div>
        </Section>
        <div className="custom-hr mt-4"></div>

        <PremiumCredits />
    </Layout>
  );
};

export default Pricing;
